export default function SendNotificationDialog() {
  return <div>SendNotificationDialog</div>;
}
